import { render } from "./ShowBranchOffice.vue?vue&type=template&id=5170f00b&scoped=true"
import script from "./ShowBranchOffice.vue?vue&type=script&lang=js"
export * from "./ShowBranchOffice.vue?vue&type=script&lang=js"

import "./ShowBranchOffice.vue?vue&type=style&index=0&id=5170f00b&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5170f00b"]])

export default __exports__